import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { User } from "../../providers";
import { TrainingListComponent } from "./training-list";

@NgModule({
  declarations: [TrainingListComponent],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [TrainingListComponent],
  providers: [User],
})
export class TrainingListModule {}



// WEBPACK FOOTER //
// ./src/app/components/training-list/training-list.module.ts